<template>
  <div class="nuovo-buono">

    <div class="header-tab">
      <div class="my-label col-24 no-padding">
        {{ $t('nuovoBuono.nuovoBuonoRitiro').toUpperCase() }}
      </div>
    </div>

    <div class="row row-custom">
      <div class="col-xl-16 col-24 colonna-sx" id="nuovoBdR-colonnaSx">
        <div class="col-24 no-padding secondButton">
          <el-button @click.native="autocomplete" class="custom-button">{{ $t('nuovoBuono.approntaTutto').toUpperCase() }}</el-button>
        </div>
        <el-table v-loading="loading" class="custom-table"
          :data="prodotti">
          <el-table-column
            prop="codProd"
            :label="$t('nuovoBuono.prodotto')"
            width="80">
          </el-table-column>
          <el-table-column
            prop="desProd" class-name="center"
            :label="$t('nuovoBuono.descrizione')"
            min-width="120">
          </el-table-column>
          <el-table-column
            header-align="center" align="center"
            :label="$t('nuovoBuono.dataConsegna')"
            min-width="120">

            <template slot-scope="scope">
              <div class="name-wrapper">
                {{ moment(scope.row.datCons, 'DDMMYYYY').format('DD/MM/YYYY') }}
              </div>
            </template>

          </el-table-column>
          <el-table-column
            prop="codUmis" header-align="center" align="center"
            :label="$t('nuovoBuono.uMis')"
            min-width="35">
          </el-table-column>
          <el-table-column
            prop="codImb" header-align="center" align="center"
            :label="$t('nuovoBuono.imballo')"
            min-width="65">
          </el-table-column>
          <el-table-column
            prop="qtaOrd" header-align="center" align="center"
            :label="$t('nuovoBuono.ordinato')"
            min-width="65">
          </el-table-column>
          <el-table-column
            prop="qtaCons" header-align="center" align="center"
            :label="$t('nuovoBuono.consegnato')"
            min-width="65">
          </el-table-column>
          <el-table-column
            header-align="center" align="center"
            :label="$t('nuovoBuono.residuo')"
            min-width="65">

            <template slot-scope="scope">
              <div class="name-wrapper">
                {{ scope.row.qtaRes | formatValueZero }}
              </div>
            </template>

          </el-table-column>
          <el-table-column class-name="center"
            :label="$t('nuovoBuono.approntato')" header-align="center" align="center"
            min-width="75">

            <template slot-scope="scope">
              <div class="name-wrapper">
                <el-input-number v-if="scope.row.ifSaldata !== 'S'" :controls="false" :precision="2" :min="0" :max="99999999.99"
                                 v-model="qtaApprontata[scope.row.codPos + '-' + scope.row.codProd]"
                                 :ref="'qtaApprontata' + scope.row.codPos + '-' + scope.row.codProd"
                                 @blur="changeQtaApp(scope.row.codPos, scope.row.codProd)"
                ></el-input-number>
              </div>
            </template>

          </el-table-column>
        </el-table>

        <el-pagination v-if="(nrPages > 1)" :current-page="currentPage" class="offset-2 col-20 no-padding custom-pagination"
                       background
                       layout="prev, pager, next"
                       :total="nrItems"
                       :page-size="pag_for"
                       @current-change="changePage">
        </el-pagination>

        <div class="col-24 no-padding form d-none d-xl-block">

          <div class="row row-custom riga">
            <div class="col-12 elemento-sx">
              <div class="form-label">
                {{ $t('nuovoBuono.puntoConsegna').toUpperCase() }}
              </div>
            </div>
            <div class="col-12 no-padding secondButton location">
              <el-tooltip class="item" effect="dark" :content="$t('nuovoBuono.gestionePuntoRit')" placement="top">
                <icon name="riv-location" class="pointer" scale="1.5" @click.native="goToAddPuntoRit"></icon>
              </el-tooltip>
              <!--
              <el-button class="custom-button" @click="goToAddPuntoRit">{{ $t('nuovoBuono.gestionePuntoRit').toUpperCase() }}</el-button>
              -->
            </div>
          </div>

          <div class="row row-custom riga">
            <div class="col-12 elemento-sx">
              <el-select v-model="form.puntoRit" value-key="codRit" placeholder="" @change="changePuntoRit" class="custom-select-el">
                <el-option
                  v-for="item in puntiRit"
                  :key="item.codRit"
                  :label="item.ragSoc"
                  :value="item">
                </el-option>
              </el-select>
            </div>
            <div class="col-12 elemento-dx">
              <el-date-picker class="custom-date-picker"
                v-model="form.dataApprontamento" :placeholder="$t('nuovoBuono.dataApprontamento') + ' '"
                type="date" format="dd/MM/yyyy" value-format="ddMMyyyy">
              </el-date-picker>
            </div>
          </div>

          <div class="row row-custom riga">
            <div class="col-12 elemento-sx">
              <el-input v-model="form.ragSoc" :disabled="true" class="custom-input"></el-input>
            </div>
            <div class="col-12 elemento-dx">
              <el-input v-model="form.interlocutore" :maxlength="20" :placeholder="$t('nuovoBuono.interlocutore') + ' '" class="custom-input"></el-input>
            </div>
          </div>

          <div class="row row-custom riga">
            <div class="col-12 elemento-sx">
              <el-input v-model="form.indRit" :disabled="true" class="custom-input"></el-input>
            </div>
            <div class="col-12 elemento-dx">
              <el-input v-model="form.telefono" :maxlength="15" :placeholder="$t('nuovoBuono.telefono') + ' '" class="custom-input"></el-input>
            </div>
          </div>

          <div class="row row-custom riga">
            <div class="col-12 elemento-sx">
              <div class="row row-custom">
                <div class="col-6 blocco-indirizzo">
                  <el-input v-model="form.capRit" :disabled="true" class="custom-input"></el-input>
                </div>
                <div class="col-14 blocco-indirizzo">
                  <el-input v-model="form.locRit" :disabled="true" class="custom-input"></el-input>
                </div>
                <div class="col-4 no-padding">
                  <el-input v-model="form.provRit" :disabled="true" class="custom-input"></el-input>
                </div>
              </div>
            </div>
            <div class="col-12 elemento-dx">
              <el-input v-model="form.mail" :maxlength="50" :placeholder="$t('nuovoBuono.mail') + ' '" class="custom-input"></el-input>
            </div>
          </div>

          <div class="label-note">
            {{ $t('nuovoBuono.note') }}
          </div>

          <el-input :maxlength="360"
            type="textarea" class="custom-input"
            resize="none"
            v-model="form.note">
          </el-input>

        </div>

      </div>

      <div class="col-xl-8 col-24 colonna-dx">
        <div class="col-24 no-padding secondButton">
          <!--
          <el-button class="custom-button" @click="goToNuovoCollo">{{ $t('nuovoBuono.aggiungiCollo').toUpperCase() }}</el-button>
          -->
          <el-tooltip class="item" effect="dark" :content="$t('nuovoBuono.aggiungiCollo')" placement="top">
            <icon name="riv-add_2" class="pointer" scale="1.4" @click.native="goToNuovoCollo" />
          </el-tooltip>
        </div>
        <el-table :data="colli" empty-text=" " @row-click="selectCollo" row-class-name="pointer" class="custom-table">
          <el-table-column
            prop="idCollo" header-align="center" align="center"
            :label="$t('nuovoBuono.collo')"
            min-width="50">
          </el-table-column>
          <el-table-column :render-header="renderHeaderAltezza"
            prop="altezza" header-align="center" align="center"
            min-width="70">
          </el-table-column>
          <el-table-column :render-header="renderHeaderLunghezza"
            prop="lunghezza" header-align="center" align="center"
            min-width="70">
          </el-table-column>
          <el-table-column :render-header="renderHeaderLarghezza"
            prop="larghezza" header-align="center" align="center"
            min-width="70">
          </el-table-column>
          <el-table-column :render-header="renderHeaderPeso"
            prop="peso" header-align="center" align="center"
            min-width="70">
          </el-table-column>
        </el-table>

        <div class="col-24 no-padding form d-xl-none">

          <div class="row row-custom riga">
            <div class="form-label col-12">
              {{ $t('nuovoBuono.puntoRit').toUpperCase() }}
            </div>
            <div class="secondButton col-12 location">
              <el-tooltip class="item" effect="dark" :content="$t('nuovoBuono.gestionePuntoRit')" placement="top">
                <icon name="riv-location" class="pointer" scale="1.5" @click.native="goToAddPuntoRit"></icon>
              </el-tooltip>
            </div>
          </div>

          <div class="row row-custom">
            <div class="form-sx col-md-12 col-24">
              <div class="riga col-24 no-padding">
                <el-select v-model="form.puntoRit" value-key="codRit" placeholder="" @change="changePuntoRit" class="custom-select-el">
                  <el-option
                    v-for="item in puntiRit"
                    :key="item.codRit"
                    :label="item.ragSoc"
                    :value="item">
                  </el-option>
                </el-select>
              </div>
              <div class="riga col-24 no-padding">
                <el-input v-model="form.ragSoc" :disabled="true" class="custom-input"></el-input>
              </div>
              <div class="riga col-24 no-padding">
                <el-input v-model="form.indRit" :disabled="true" class="custom-input"></el-input>
              </div>
              <div class="riga col-24 no-padding">
                <div class="row row-custom elemento-sx">
                  <div class="col-6 blocco-indirizzo">
                    <el-input v-model="form.capRit" :disabled="true" class="custom-input"></el-input>
                  </div>
                  <div class="col-14 blocco-indirizzo">
                    <el-input v-model="form.locRit" :disabled="true" class="custom-input"></el-input>
                  </div>
                  <div class="col-4 no-padding">
                    <el-input v-model="form.provRit" :disabled="true" class="custom-input"></el-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-dx col-md-12 col-24">
              <div class="riga col-24 no-padding">
                <el-date-picker
                  v-model="form.dataApprontamento" :placeholder="$t('nuovoBuono.dataApprontamento') + ' '" class="custom-date-picker elemento-dx"
                  type="date" format="dd/MM/yyyy" value-format="ddMMyyyy">
                </el-date-picker>
              </div>
              <div class="riga col-24 no-padding">
                <el-input v-model="form.interlocutore" :maxlength="20" :placeholder="$t('nuovoBuono.interlocutore') + ' '" class="custom-input elemento-dx"></el-input>
              </div>
              <div class="riga col-24 no-padding">
                <el-input v-model="form.telefono" :maxlength="15" :placeholder="$t('nuovoBuono.telefono') + ' '" class="custom-input elemento-dx"></el-input>
              </div>
              <div class="riga col-24 no-padding">
                <el-input v-model="form.mail" :maxlength="50" :placeholder="$t('nuovoBuono.mail') + ' '" class="custom-input elemento-dx"></el-input>
              </div>
            </div>
          </div>

          <div class="label-note col-sm-24">
            {{ $t('nuovoBuono.note') }}
          </div>

          <el-input class="col-sm-24 custom-input" :maxlength="360"
            type="textarea"
            resize="none"
            v-model="form.note">
          </el-input>

        </div>

        <div class="col-24 no-padding totali">
          <div class="row row-custom">
            <div class="col-md-20 col-sm-21 col-19 totali-label">
              {{ $t('nuovoBuono.totaleColli') }}
            </div>
            <div class="col-md-4 col-sm-3 col-5 totali-value no-padding">
              {{ totaleColli }}
            </div>
          </div>
          <div class="row row-custom">
            <div class="col-md-20 col-sm-21 col-19 totali-label">
              {{ $t('nuovoBuono.totalePeso') + ' (KG)' }}
            </div>
            <div class="col-md-4 col-sm-3 col-5 totali-value no-padding">
              {{ totalePeso }}
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="col-24 salva">
      <el-button class="custom-button" type="primary" @click="goToSalva">{{ $t('nuovoBuono.salva').toUpperCase() }}</el-button>
    </div>

    <el-dialog class="colli-modal" :title="$t('nuovoBuono.nuovoCollo').toUpperCase()"
               :visible.sync="showNuovoCollo" :append-to-body="true"
               custom-class="custom-dialog offset-xl-8 col-xl-8 offset-lg-7 col-lg-10 offset-md-6 col-md-12 offset-sm-4 col-sm-16 offset-2 col-20">

      <div class="form">
        <div class="row row-custom">
          <div class="collo-label col-9 no-padding">
            {{ $t('nuovoBuono.collo') }}
          </div>
          <div class="collo-value col-11">
            {{ formCollo.idCollo }}
          </div>
        </div>
        <div class="row row-custom">
          <div class="collo-label col-9 no-padding">
            {{ $t('nuovoBuono.altezza') + ' (mm)' }}
          </div>
          <div class="collo-value col-11">
            <el-input-number v-model="formCollo.altezza" :min="0" :max="100000" :precision="0" :controls="false" ref="altezza" class="custom-input"></el-input-number>
          </div>
        </div>
        <div class="row row-custom">
          <div class="collo-label col-9 no-padding">
            {{ $t('nuovoBuono.lunghezza') + ' (mm)' }}
          </div>
          <div class="collo-value col-11">
            <el-input-number v-model="formCollo.lunghezza" :min="0" :max="100000" :precision="0" :controls="false" ref="lunghezza" class="custom-input"></el-input-number>
          </div>
        </div>
        <div class="row row-custom">
          <div class="collo-label col-9 no-padding">
            {{ $t('nuovoBuono.larghezza') + ' (mm)' }}
          </div>
          <div class="collo-value col-11">
            <el-input-number v-model="formCollo.larghezza" :min="0" :max="100000" :precision="0" :controls="false" ref="larghezza" class="custom-input"></el-input-number>
          </div>
        </div>
        <div class="row row-custom">
          <div class="collo-label col-9 no-padding">
            {{ $t('nuovoBuono.peso') + ' (Kg)' }}
          </div>
          <div class="collo-value col-11">
            <el-input-number v-model="formCollo.peso" :min="0" :max="100000" :precision="0" :controls="false" ref="peso" class="custom-input"></el-input-number>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="bottoni">
          <el-button class="custom-button" @click="deleteCollo" v-if="formCollo.modifica === true">{{ $t('nuovoBuono.elimina').toUpperCase() }}</el-button>
          <el-button class="custom-button" type="primary" @click="salvaCollo" :disabled="!canSaveCollo">{{ $t('nuovoBuono.salva').toUpperCase() }}</el-button>
        </div>
      </span>

    </el-dialog>

    <el-dialog class="puntorit-modal" :title="$t('nuovoBuono.puntoRit').toUpperCase()"
               :visible.sync="showAddPuntoRit" :append-to-body="true"
               custom-class="custom-dialog offset-lg-6 col-lg-12 offset-md-5 col-md-14 offset-sm-3 col-sm-18 offset-1 col-22">

      <el-tabs type="card" @tab-click="changeTab" class="custom-tabs">

        <el-tab-pane>
          <div slot="label">
            <div class="col-24 no-padding">
              {{ $t('nuovoBuono.elencoPuntiRit') }}
            </div>
            <div class="col-24 no-padding barra"></div>
          </div>
          <el-table :data="puntiRit" class="custom-table">
            <el-table-column
              prop="ragSoc"
              :label="$t('nuovoBuono.ragSoc')"
              min-width="150">
            </el-table-column>
            <el-table-column
              :label="$t('nuovoBuono.indirizzo')"
              min-width="250">

              <template slot-scope="scope">
                <div class="name-wrapper">
                  {{ scope.row.indRit + ' - ' + scope.row.capRit + ', ' + scope.row.locRit + ' - ' + scope.row.provRit }}
                </div>
              </template>

            </el-table-column>
            <el-table-column
              width="100">

              <template slot-scope="scope">
                <div class="name-wrapper">
                  <div class="row row-custom">
                    <div class="col-12" v-if="(scope.row.codRit !== '')">
                      <el-tooltip class="item" effect="dark" :content="$t('nuovoBuono.modifica')" placement="top">
                        <icon class="pointer" name="riv-prenotazione" @click.native="modificaPuntoRit(scope.row)"></icon>
                      </el-tooltip>
                    </div>
                    <div class="col-12" v-if="(scope.row.codRit !== '')">
                      <el-tooltip class="item" effect="dark" :content="$t('nuovoBuono.cancella')" placement="top">
                        <icon class="pointer" name="riv-delete2" @click.native="openCancDialog(scope.row)"></icon>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </template>

            </el-table-column>
          </el-table>

          <div class="form-puntorit col-24 no-padding" style="margin-top: 25px" v-if="canModificarePuntoRit">
            <div class="form-elemento row row-custom">
              <div class="col-10 puntorit-label">
                {{ $t('nuovoBuono.ragSoc') }}
              </div>
              <div class="col-8 puntorit-value">
                <el-input class="custom-input" v-model="formModificaPuntoRit.ragSoc" :maxlength="30"></el-input>
              </div>
            </div>
            <div class="form-elemento row row-custom">
              <div class="col-10 puntorit-label">
                {{ $t('nuovoBuono.indirizzo') }}
              </div>
              <div class="col-8 puntorit-value">
                <el-input class="custom-input" v-model="formModificaPuntoRit.indRit" :maxlength="30"></el-input>
              </div>
            </div>
            <div class="form-elemento row row-custom">
              <div class="col-10 puntorit-label">
                {{ $t('nuovoBuono.cap') }}
              </div>
              <div class="col-8 puntorit-value">
                <el-input class="custom-input" v-model="formModificaPuntoRit.capRit" :maxlength="5"></el-input>
              </div>
            </div>
            <div class="form-elemento row row-custom">
              <div class="col-10 puntorit-label">
                {{ $t('nuovoBuono.loc') }}
              </div>
              <div class="col-8 puntorit-value">
                <el-input class="custom-input" v-model="formModificaPuntoRit.locRit" :maxlength="30"></el-input>
              </div>
            </div>
            <div class="form-elemento row row-custom">
              <div class="col-10 puntorit-label">
                {{ $t('nuovoBuono.prov') }}
              </div>
              <div class="col-8 puntorit-value">
                <el-input class="custom-input" v-model="formModificaPuntoRit.provRit" :maxlength="2"></el-input>
              </div>
            </div>
            <div class="form-elemento row row-custom">
              <div class="col-10 puntorit-label">
                {{ $t('nuovoBuono.stato') }}
              </div>
              <div class="col-8 puntorit-value">
                <el-select class="custom-select-el" v-model="formModificaPuntoRit.statoRit">
                  <el-option
                    v-for="item in countries"
                    :key="item"
                    :label="($t('nuovoBuono')[item])"
                    :value="item">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>

          <div class="bottone-puntorit">
            <el-button class="custom-button" type="primary" @click="salvaPuntoRit('UPD')" v-if="canModificarePuntoRit">{{ $t('nuovoBuono.salva').toUpperCase() }}</el-button>
          </div>
        </el-tab-pane>

        <el-tab-pane>
          <div slot="label">
            <div class="col-24 no-padding">
              {{ $t('nuovoBuono.nuovoPuntoRit') }}
            </div>
            <div class="col-24 no-padding barra"></div>
          </div>
          <div class="form-puntorit col-24 no-padding">
            <div class="form-elemento row row-custom">
              <div class="col-10 no-padding puntorit-label">
                {{ $t('nuovoBuono.ragSoc') }}
              </div>
              <div class="col-8 puntorit-value">
                <el-input v-model="formNuovoPuntoRit.ragSoc" :maxlength="30" class="custom-input"></el-input>
              </div>
            </div>
            <div class="form-elemento row row-custom">
              <div class="col-10 no-padding puntorit-label">
                {{ $t('nuovoBuono.indirizzo') }}
              </div>
              <div class="col-8 puntorit-value">
                <el-input v-model="formNuovoPuntoRit.indRit" :maxlength="30" class="custom-input"></el-input>
              </div>
            </div>
            <div class="form-elemento row row-custom">
              <div class="col-10 no-padding puntorit-label">
                {{ $t('nuovoBuono.cap') }}
              </div>
              <div class="col-8 puntorit-value">
                <el-input v-model="formNuovoPuntoRit.capRit" :maxlength="5" class="custom-input"></el-input>
              </div>
            </div>
            <div class="form-elemento row row-custom">
              <div class="col-10 no-padding puntorit-label">
                {{ $t('nuovoBuono.loc') }}
              </div>
              <div class="col-8 puntorit-value">
                <el-input v-model="formNuovoPuntoRit.locRit" :maxlength="30" class="custom-input"></el-input>
              </div>
            </div>
            <div class="form-elemento row row-custom">
              <div class="col-10 no-padding puntorit-label">
                {{ $t('nuovoBuono.prov') }}
              </div>
              <div class="col-8 puntorit-value">
                <el-input v-model="formNuovoPuntoRit.provRit" :maxlength="2" class="custom-input"></el-input>
              </div>
            </div>
            <div class="form-elemento row row-custom">
              <div class="col-10 no-padding puntorit-label">
                {{ $t('nuovoBuono.stato') }}
              </div>
              <div class="col-8 puntorit-value">
                <el-select v-model="formNuovoPuntoRit.statoRit" class="custom-select-el">
                  <el-option
                    v-for="item in countries"
                    :key="item"
                    :label="($t('nuovoBuono')[item])"
                    :value="item">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>

          <div class="bottone-puntorit">
            <el-button class="custom-button" @click="setPuntoRitTemporaneo">{{ $t('nuovoBuono.usaPuntoRitTemporaneo').toUpperCase() }}</el-button>
            <el-button class="custom-button" type="primary" @click="salvaPuntoRit('ADD')">{{ $t('nuovoBuono.salva').toUpperCase() }}</el-button>
          </div>
        </el-tab-pane>

      </el-tabs>

    </el-dialog>

    <el-dialog :title="$t('nuovoBuono.titoloCancModal').toUpperCase()"
               :visible.sync="showCancellaModal" :append-to-body="true"
               custom-class="custom-dialog offset-xl-8 col-xl-8 offset-lg-7 col-lg-10 offset-md-6 col-md-12 offset-sm-4 col-sm-16 offset-2 col-20">

      <div>{{ $t('nuovoBuono.cancellare') }}</div>

      <span slot="footer" class="dialog-footer">
        <div class="bottoni">
          <el-button class="custom-button" @click="showCancellaModal = false">{{ $t('nuovoBuono.annulla').toUpperCase() }}</el-button>
          <el-button class="custom-button" type="primary" @click="cancellaPuntoRit">{{ $t('nuovoBuono.elimina').toUpperCase() }}</el-button>
        </div>
      </span>

    </el-dialog>

    <el-dialog :title="$t('nuovoBuono.titoloIfSalvaModal').toUpperCase()"
               :visible.sync="showIfSalva" :append-to-body="true"
               custom-class="custom-dialog offset-xl-8 col-xl-8 offset-lg-7 col-lg-10 offset-md-6 col-md-12 offset-sm-4 col-sm-16 offset-2 col-20">

      <div>{{ $t('nuovoBuono.ifSalvare') }}</div>
      <span slot="footer" class="dialog-footer">
        <div class="bottoni">
          <el-button class="custom-button" @click="showIfSalva = false">{{ $t('nuovoBuono.annulla').toUpperCase() }}</el-button>
          <el-button class="custom-button" type="primary" @click="salvaBuono" :loading="saveDisabled">{{ $t('nuovoBuono.salva').toUpperCase() }}</el-button>
        </div>
      </span>

    </el-dialog>

  </div>
</template>

<script>
  import {bus} from '@/components/Bus.js'
  import moment from 'moment'

  export default {
    name: 'NuovoBuono',
    i18n: {
      messages: {
        it_IT: {
          nuovoBuono: {
            collo: 'Collo',
            altezza: 'Altezza',
            lunghezza: 'Lunghezza',
            larghezza: 'Larghezza',
            peso: 'Peso',
            aggiungiCollo: 'Aggiungi',
            nuovoCollo: 'Nuovo Collo',
            salva: 'Salva',
            totaleColli: 'Totale Colli',
            totalePeso: 'Totale Peso',
            dataApprontamento: 'Data Approntamento',
            interlocutore: 'Interlocutore',
            telefono: 'Telefono',
            mail: 'Mail',
            puntoRit: 'Punto di Ritiro',
            cancella: 'Cancella',
            modifica: 'Modifica',
            ragSoc: 'Ragione Sociale',
            indirizzo: 'Indirizzo',
            cap: 'CAP',
            loc: 'Località',
            prov: 'Provincia',
            titoloCancModal: 'Cancellazione Punto di Ritiro',
            cancellare: 'Cancellare definitivamente il Punto di Ritiro?',
            annulla: 'Annulla',
            elimina: 'Elimina',
            elencoPuntiRit: 'Elenco Punti di Ritiro',
            nuovoPuntoRit: 'Nuovo Punto di Ritiro',
            usaPuntoRitTemporaneo: 'Ritira a questo indirizzo',
            nuovoBuonoRitiro: 'Nuovo Buono di Ritiro',
            elencoProdotti: 'Elenco Prodotti',
            approntato: 'Approntato',
            prodotto: 'Prodotto',
            descrizione: 'Descrizione',
            dataConsegna: 'Data consegna',
            uMis: 'UM',
            imballo: 'Imballo',
            ordinato: 'Ordinato',
            consegnato: 'Consegnato',
            residuo: 'Residuo',
            puntoConsegna: 'Punto di Ritiro',
            note: 'NOTE: (es. orari di ritiro, richieste di mezzi particolari, ecc.)',
            titoloIfSalvaModal: 'Salvataggio buono',
            ifSalvare: 'Procedere al salvataggio?',
            erroreQta: 'Inserire almeno una quantità approntata',
            approntaTutto: 'Appronta Tutto',
            gestionePuntoRit: 'Gestione Punto di Ritiro',
            1: 'Italia',
            2: 'Francia',
            3: 'Spagna',
            4: 'Belgio',
            5: 'Germania',
            A: 'Altro...',
            stato: 'Stato'
          }
        },
        fr_FR: {
          nuovoBuono: {
            collo: 'Colis',
            altezza: 'Hauteur',
            lunghezza: 'Longueur',
            larghezza: 'Largeur',
            peso: 'Poids',
            aggiungiCollo: 'Ajouter un Colis',
            nuovoCollo: 'Nouveau Colis',
            salva: 'Enregistrer',
            totaleColli: 'Total des Colis',
            totalePeso: 'Poids Total',
            dataApprontamento: 'Préparation des Données',
            interlocutore: 'Contact',
            telefono: 'Téléphone',
            mail: 'Email',
            puntoRit: 'Point de Livraison',
            cancella: 'Clair',
            modifica: 'Éditer',
            ragSoc: 'Nom de l\'Entreprise',
            indirizzo: 'Adresse',
            cap: 'CAP',
            loc: 'Emplacement',
            prov: 'Province',
            titoloCancModal: 'Annulation du Point de Livraison',
            cancellare: 'Supprimer définitivement le Point de Livraison?',
            annulla: 'Annuler',
            elimina: 'Effacer',
            elencoPuntiRit: 'Liste des Points de Livraison',
            nuovoPuntoRit: 'Nouveau Point de Livraison',
            usaPuntoRitTemporaneo: 'Utiliser un Point de Livraison Temporaire',
            nuovoBuonoRitiro: 'Nouveau Coupon de Collection',
            elencoProdotti: 'Liste de Produits',
            approntato: 'Opéré',
            prodotto: 'Produit',
            descrizione: 'Description',
            dataConsegna: 'Date de livraison',
            uMis: 'UM',
            imballo: 'Emballage',
            ordinato: 'Ordonné',
            consegnato: 'Livré',
            residuo: 'Résiduel',
            puntoConsegna: 'Point de Livraison',
            note: 'Notes',
            titoloIfSalvaModal: 'Bon sauvetage',
            ifSalvare: 'Procéder à la rescousse?',
            erroreQta: 'Entrez au moins une quantité préparée',
            approntaTutto: 'Tout Préparer',
            gestionePuntoRit: 'Gestion des Points de Ramassage',
            1: 'Italie',
            2: 'France',
            3: 'Espagne',
            4: 'Belgique',
            5: 'Allemagne',
            A: 'Autre...',
            stato: 'Pays'
          }
        },
        es_ES: {
          nuovoBuono: {
            collo: 'Paquete',
            altezza: 'Altura',
            lunghezza: 'Longitud',
            larghezza: 'Ancho',
            peso: 'Peso',
            aggiungiCollo: 'Añadir Paquete',
            nuovoCollo: 'Nuevo Paquete',
            salva: 'Guardar',
            totaleColli: 'Total de Paquetes',
            totalePeso: 'Peso Total',
            dataApprontamento: 'Fecha disponibilidad material',
            interlocutore: 'Contacto',
            telefono: 'Teléfono',
            mail: 'E-mail',
            puntoRit: 'Punto de retirada',
            cancella: 'claro',
            modifica: 'Editar',
            ragSoc: 'Nombre de la Compañía',
            indirizzo: 'Dirección',
            cap: 'PAC',
            loc: 'Ubicación',
            prov: 'Provincia',
            titoloCancModal: 'Cancelación del Punto de Entrega',
            cancellare: '¿Eliminar permanentemente el Punto de Entrega?',
            annulla: 'Cancelar',
            elimina: 'Borrar',
            elencoPuntiRit: 'Lista de Puntos de Retirada',
            nuovoPuntoRit: 'Nuevo Punto de Retirada',
            usaPuntoRitTemporaneo: 'Use el punto de retirada temporal',
            nuovoBuonoRitiro: 'Nuevo aviso de retirada',
            elencoProdotti: 'Lista de Productos',
            approntato: 'Preparado',
            prodotto: 'Producto',
            descrizione: 'Descripción',
            dataConsegna: 'Fecha de entrega',
            uMis: 'UM',
            imballo: 'Embalaje',
            ordinato: 'Ordenado',
            consegnato: 'Liberado',
            residuo: 'Residual',
            puntoConsegna: 'Punto de Retirada',
            note: 'Notas',
            titoloIfSalvaModal: 'Ahorro de cupones',
            ifSalvare: 'Proceder al rescate?',
            erroreQta: 'Ingrese al menos una cantidad preparada',
            approntaTutto: 'Preparar Todo',
            gestionePuntoRit: 'Gestión de Puntos de Retirada',
            1: 'Italia',
            2: 'Francia',
            3: 'España',
            4: 'Bélgica',
            5: 'Alemania',
            A: 'Más...',
            stato: 'Estado'
          }
        },
        de_DE: {
          nuovoBuono: {
            collo: 'Paket',
            altezza: 'Höhe',
            lunghezza: 'Länge',
            larghezza: 'Breite',
            peso: 'Gewicht',
            aggiungiCollo: 'Paket Hinzufügen',
            nuovoCollo: 'Neues Paket',
            salva: 'Speichern',
            totaleColli: 'Gesamtanzahl Pakete',
            totalePeso: 'Gesamtgewicht',
            dataApprontamento: 'Datenvorbereitung',
            interlocutore: 'Kontakt',
            telefono: 'Telefon',
            mail: 'eMail',
            puntoRit: 'Lieferpunkt',
            cancella: 'Klar',
            modifica: 'Bearbeiten',
            ragSoc: 'Firmenname',
            indirizzo: 'Adresse',
            cap: 'PLZ',
            loc: 'Ort',
            prov: 'Region',
            titoloCancModal: 'Stornierung des Lieferpunktes',
            cancellare: 'Den Übergabepunkt dauerhaft löschen?',
            annulla: 'Stornieren',
            elimina: 'Löschen',
            elencoPuntiRit: 'Liste der Lieferpunkte',
            nuovoPuntoRit: 'Neuer Lieferpunkt',
            usaPuntoRitTemporaneo: 'Abholung an dieser Adresse',
            nuovoBuonoRitiro: 'Neuer Sammelcoupon',
            elencoProdotti: 'Produktliste',
            approntato: 'Vorbereitet',
            prodotto: 'Produkt',
            descrizione: 'Beschreibung',
            dataConsegna: 'Lieferdatum',
            uMis: 'Maßeinheit',
            imballo: 'Verpackung',
            ordinato: 'Bestellt',
            consegnato: 'Geliefert',
            residuo: 'Noch offen',
            puntoConsegna: 'Lieferpunkt',
            note: 'Hinweise',
            titoloIfSalvaModal: 'Gutschein speichern',
            ifSalvare: 'Weiter zur Rettung?',
            erroreQta: 'Geben Sie mindestens eine bereitgestellte Menge ein',
            approntaTutto: 'Bereite Alles Vor',
            gestionePuntoRit: 'Abholstellenverwaltung',
            1: 'Italien',
            2: 'Frankreich',
            3: 'Spanien',
            4: 'Belgien',
            5: 'Deutschland',
            A: 'Mehr...',
            stato: 'Land'
          }
        },
        en_GB: {
          nuovoBuono: {
            collo: 'Package',
            altezza: 'Height',
            lunghezza: 'Length',
            larghezza: 'Width',
            peso: 'Weight',
            aggiungiCollo: 'Add Package',
            nuovoCollo: 'New Package',
            salva: 'Save',
            totaleColli: 'Total Packages',
            totalePeso: 'Total Weight',
            dataApprontamento: 'Preparation Date',
            interlocutore: 'Contact',
            telefono: 'Phone',
            mail: 'Email',
            puntoRit: 'Delivery Point',
            cancella: 'Clear',
            modifica: 'Edit',
            ragSoc: 'Business name',
            indirizzo: 'Address',
            cap: 'P.C.',
            loc: 'Location',
            prov: 'Province',
            titoloCancModal: 'Cancellation of Delivery Point',
            cancellare: 'Permanently delete the Delivery Point?',
            annulla: 'Cancel',
            elimina: 'Delete',
            elencoPuntiRit: 'List of Delivery Points',
            nuovoPuntoRit: 'New Delivery Point',
            usaPuntoRitTemporaneo: 'Use Temporary Delivery Point',
            nuovoBuonoRitiro: 'New Collection Voucher',
            elencoProdotti: 'Product List',
            approntato: 'Prepared',
            prodotto: 'Product',
            descrizione: 'Description',
            dataConsegna: 'Delivery date',
            uMis: 'UM',
            imballo: 'Packaging',
            ordinato: 'Ordered',
            consegnato: 'Delivered',
            residuo: 'Residue',
            puntoConsegna: 'Delivery Point',
            note: 'Notes',
            titoloIfSalvaModal: 'Voucher Save',
            ifSalvare: 'Proceed to save?',
            erroreQta: 'Enter at least one quantity prepared',
            approntaTutto: 'Prepare Everything',
            gestionePuntoRit: 'Pick-up Point Management',
            1: 'Italy',
            2: 'France',
            3: 'Spain',
            4: 'Belgium',
            5: 'Germania',
            A: 'Other...',
            stato: 'Country'
          }
        }
      }
    },
    filters: {
      formatValueZero: function (val) {
        if (val === '0,00' || val === null || val === undefined) {
          return '-'
        }
        return val
      }
    },
    props: {
      prefixApp: {
        type: String
      }
    },
    data () {
      return {
        moment: moment,
        saveDisabled: false,
        qtaApprontata: {},
        codLang: sessionStorage.getItem('codLang'),
        prodotti: [],
        colli: [],
        ordine: {},
        pag_for: 8,
        currentPage: 1,
        nrPages: 0,
        nrItems: 0,
        puntiRit: [],
        form: {
          puntoRit: {
            capRit: '',
            codRit: '',
            indRit: '',
            locRit: '',
            provRit: '',
            ragSoc: ''
          },
          dataApprontamento: '',
          ragSoc: '',
          interlocutore: sessionStorage.getItem('nomeFornitore'),
          indRit: '',
          telefono: sessionStorage.getItem('telefonoFornitore'),
          capRit: '',
          locRit: '',
          provRit: '',
          mail: sessionStorage.getItem('mailFornitore'),
          note: ''
        },
        showNuovoCollo: false,
        showAddPuntoRit: false,
        showCancellaModal: false,
        progressivoCollo: 1,
        formCollo: {
          idCollo: '',
          altezza: '0',
          lunghezza: '0',
          larghezza: 0,
          peso: 0,
          modifica: false
        },
        totaleColli: 0,
        totalePeso: 0,
        formModificaPuntoRit: {
          ragSoc: '',
          indRit: '',
          capRit: '',
          locRit: '',
          provRit: '',
          statoRit: ''
        },
        formNuovoPuntoRit: {
          ragSoc: '',
          indRit: '',
          capRit: '',
          locRit: '',
          provRit: '',
          statoRit: ''
        },
        puntoRitToDelete: {},
        canModificarePuntoRit: false,
        showIfSalva: false,
        loading: true,
        ifApprontatoTutto: {},
        countries: ['1', '2', '3', '4', '5', 'A']
      }
    },
    computed: {
      canSaveCollo: function () {
        return (this.formCollo.collo !== '' && this.formCollo.altezza !== '' && this.formCollo.lunghezza !== '' && this.formCollo.larghezza !== '' && this.formCollo.peso !== '')
      }
    },
    watch: {
      colli: function (newVal, oldVal) {
        let totPeso = 0
        for (let i = 0; i < this.colli.length; i++) {
          totPeso = totPeso + parseInt(this.colli[i].peso)
        }
        this.$set(this, 'totaleColli', this.colli.length)
        this.$set(this, 'totalePeso', totPeso)
      }
    },
    mounted: function () {
      bus.$on('changeLanguage', () => {
        this.$set(this, 'codLang', sessionStorage.getItem('codLang'))
      })
    },
    activated: function () {
      this.init()
    },
    deactivated: function () {
      this.resetDati()
    },
    methods: {
      init: function () {
        this.$nextTick(() => {
          if (sessionStorage.hasOwnProperty(this.prefixApp + '_ordine')) {
            this.$set(this, 'ordine', JSON.parse(sessionStorage.getItem(this.prefixApp + '_ordine')))
            this.loadOrdine()
            this.listPuntiRit()
          } else {
            this.$router.push({ name: this.prefixApp + 'Ordini' })
          }
        })
      },
      resetDati: function () {
        let form = {
          puntoRit: {
            capRit: '',
            codRit: '',
            indRit: '',
            locRit: '',
            provRit: '',
            statoRit: '',
            ragSoc: ''
          },
          dataApprontamento: '',
          ragSoc: '',
          interlocutore: sessionStorage.getItem('nomeFornitore'),
          indRit: '',
          telefono: sessionStorage.getItem('telefonoFornitore'),
          capRit: '',
          locRit: '',
          provRit: '',
          mail: sessionStorage.getItem('mailFornitore'),
          note: ''
        }
        this.$set(this, 'form', form)
        this.$set(this, 'prodotti', [])
        this.$set(this, 'colli', [])
        this.$set(this, 'ordine', {})
        this.$set(this, 'qtaApprontata', {})
        this.$set(this, 'currentPage', 1)
        this.$set(this, 'nrPages', 0)
        this.$set(this, 'nrItems', 0)
        this.$set(this, 'puntiRit', [])
        this.$set(this, 'showNuovoCollo', false)
        this.$set(this, 'showAddPuntoRit', false)
        this.$set(this, 'showCancellaModal', false)
        this.$set(this, 'progressivoCollo', 1)

        let formCollo = {
          idCollo: '',
          altezza: '0',
          lunghezza: '0',
          larghezza: 0,
          peso: 0,
          modifica: false
        }
        this.$set(this, 'formCollo', formCollo)
        this.$set(this, 'totaleColli', 0)
        this.$set(this, 'totalePeso', 0)

        let formModificaPuntoRit = {
          ragSoc: '',
          indRit: '',
          capRit: '',
          locRit: '',
          provRit: '',
          statoRit: ''
        }
        this.$set(this, 'formModificaPuntoRit', formModificaPuntoRit)

        let formNuovoPuntoRit = {
          ragSoc: '',
          indRit: '',
          capRit: '',
          locRit: '',
          provRit: '',
          statoRit: ''
        }
        this.$set(this, 'formNuovoPuntoRit', formNuovoPuntoRit)

        this.$set(this, 'puntoRitToDelete', {})
        this.$set(this, 'canModificarePuntoRit', false)
        this.$set(this, 'showIfSalva', false)
        this.$set(this, 'saveDisabled', false)
        this.$set(this, 'ifApprontatoTutto', {})
      },
      changeQtaApp: function (codPos, codProd) {
        let qta = parseFloat(this.$refs['qtaApprontata' + codPos + '-' + codProd].$refs.input.$refs.input.value.replace(/,/g, '.'))
        this.$set(this.qtaApprontata, codPos + '-' + codProd, qta)
      },
      autocomplete: function () {
        if (this.ifApprontatoTutto[this.currentPage] !== true) {
          this.prodotti.forEach((prd, index) => {
            if (parseInt(prd.qtaRes) > 0) {
              this.$set(this.qtaApprontata, prd.codPos + '-' + prd.codProd, parseInt(prd.qtaRes))
            }
          })
          this.$set(this.ifApprontatoTutto, this.currentPage, true)
        } else {
          this.prodotti.forEach((prd, index) => {
            if (parseInt(prd.qtaRes) > 0) {
              this.$set(this.qtaApprontata, prd.codPos + '-' + prd.codProd, 0)
            }
          })
          this.$set(this.ifApprontatoTutto, this.currentPage, false)
        }
      },
      goToSalva: function () {
        this.$set(this, 'showIfSalva', true)
      },
      renderHeaderAltezza: function (h, {column, $index}) {
        return this.renderHeaderColli(h, {column, $index}, 'altezza', '(mm)')
      },
      renderHeaderLunghezza: function (h, {column, $index}) {
        return this.renderHeaderColli(h, {column, $index}, 'lunghezza', '(mm)')
      },
      renderHeaderLarghezza: function (h, {column, $index}) {
        return this.renderHeaderColli(h, {column, $index}, 'larghezza', '(mm)')
      },
      renderHeaderPeso: function (h, {column, $index}) {
        return this.renderHeaderColli(h, {column, $index}, 'peso', '(Kg)')
      },
      renderHeaderColli: function (h, {column, $index}, label, umis) {
        let _this = this
        let primaRiga = h('div', {class: 'label-colli'}, _this.$t('nuovoBuono')[label])
        let separatore = h('br')
        let secondaRiga = h('div', {class: 'umis-colli'}, umis)
        let result = h('div', {
          class: 'header-colli'
        }, [primaRiga, separatore, secondaRiga])
        return result
      },
      modificaPuntoRit: function (puntoRitToModify) {
        this.$set(this.formModificaPuntoRit, 'ragSoc', puntoRitToModify.ragSoc)
        this.$set(this.formModificaPuntoRit, 'indRit', puntoRitToModify.indRit)
        this.$set(this.formModificaPuntoRit, 'capRit', puntoRitToModify.capRit)
        this.$set(this.formModificaPuntoRit, 'locRit', puntoRitToModify.locRit)
        this.$set(this.formModificaPuntoRit, 'provRit', puntoRitToModify.provRit)
        this.$set(this.formModificaPuntoRit, 'statoRit', puntoRitToModify.statoRit)
        this.$set(this.formModificaPuntoRit, 'codRit', puntoRitToModify.codRit)
        this.$set(this, 'canModificarePuntoRit', true)
      },
      changeTab: function (tab) {
        this.$set(this, 'canModificarePuntoRit', false)
      },
      openCancDialog: function (puntoRitToDelete) {
        this.$set(this, 'showCancellaModal', true)
        this.$set(this, 'puntoRitToDelete', puntoRitToDelete)
      },
      changePuntoRit: function (newPuntoRit) {
        this.$set(this.form, 'ragSoc', newPuntoRit.ragSoc)
        this.$set(this.form, 'indRit', newPuntoRit.indRit)
        this.$set(this.form, 'capRit', newPuntoRit.capRit)
        this.$set(this.form, 'locRit', newPuntoRit.locRit)
        this.$set(this.form, 'provRit', newPuntoRit.provRit)
        this.$set(this.form, 'statoRit', newPuntoRit.statoRit)
      },
      goToAddPuntoRit: function () {
        this.$set(this, 'canModificarePuntoRit', false)
        this.$set(this, 'showAddPuntoRit', true)
      },
      salvaBuono: function () {
        this.$set(this, 'saveDisabled', true)
        let quantita = []
        for (let key in this.qtaApprontata) {
          let obj = {
            codPos: key.split('-')[0],
            codPro: key.split('-')[1],
            qtaApp: this.qtaApprontata[key]
          }
          if(obj.qtaApp !== '' && obj.qtaApp !== '0' && obj.qtaApp !== undefined && obj.qtaApp !== null && parseFloat(obj.qtaApp) > 0) {
            quantita.push(obj)
          }
        }
        let array = JSON.parse(JSON.stringify(this.colli))
        for (let i = 0; i < this.colli.length; i++) {
          delete array[i].modifica
        }
        this.$set(this, 'colli', array)
        if(quantita.length > 0) {
          let obj = {
            codLang: this.codLang,
            codStato: this.ordine.country,
            codForn: this.ordine.codForn,
            codMag: this.ordine.codMag,
            numOrd: this.ordine.numOrd,
            annoOrd: this.ordine.annoOrd,
            codSoc: this.ordine.codSoc,
            totColli: this.totaleColli,
            totPeso: this.totalePeso,
            codRit: this.form.puntoRit.codRit,
            ragSoc: this.form.ragSoc,
            indRit: this.form.indRit,
            capRit: this.form.capRit,
            locRit: this.form.locRit,
            provRit: this.form.provRit.toUpperCase(),
            statoRit: this.form.statoRit,
            dataAppront: this.form.dataApprontamento,
            interlocutore: this.form.interlocutore,
            tel: this.form.telefono,
            mail: this.form.mail,
            note: this.form.note,
            colli: this.colli,
            quantita: quantita
          }
          this.$http.post('situazioneordini/' + this.prefixApp.toLowerCase() + '/buonorit', obj)
            .then(response => {
              this.$set(this, 'showIfSalva', false)
              if (response.body.rc === 0) {
                this.$alert(response.body.msg[0].msgTxt + ' ' + response.body.data.numBuono, this.$t('nuovoBuono.titoloIfSalvaModal').toUpperCase(), {
                  confirmButtonText: 'OK',
                  showClose: false,
                  callback: async (action) => {
                    const rs = await this.$http.get('portale/tokendoc')
                    if (rs.body.wsToken) {
                      let url = (process.env.baseUrlSpringAcquisti + 'print/ordini/buonodiritiro' +
                        '?codLang=' + this.codLang +
                        '&country=' + this.ordine.country +
                        '&codForn=' + this.ordine.codForn +
                        '&numBuono=' + response.body.data.numBuono +
                        '&appName=' + ((this.prefixApp === 'SO') ? 'SituazioneOrdini' : 'WebBuoniDiRitiro') +
                        '&token=' + rs.body.wsToken
                      )
                      let win = window.open(url, '_blank')
                      win.focus()
                    } else {
                      this.$message({
                        showClose: true,
                        message: 'Error creating token',
                        type: 'error',
                        duration: process.env.duration
                      })
                    }

                    this.$router.push({name: this.prefixApp + 'DettaglioOrdine', params: { afterSave: true }})
                  }
                })
              } else {
                this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'error',
                  duration: process.env.duration
                })
              }
              this.$set(this, 'saveDisabled', false)
            })
        } else {
          this.$set(this, 'showIfSalva', false)
          this.$message({
            showClose: true,
            message: this.$t('nuovoBuono.erroreQta'),
            type: 'error',
            duration: process.env.duration
          })
          this.$set(this, 'saveDisabled', false)
        }
      },
      salvaCollo: function () {
        let flag = null
        for (let i = 0; i < this.colli.length; i++) {
          if (this.colli[i].idCollo === this.formCollo.idCollo) {
            flag = i
          }
        }
        let collo = {
          idCollo: this.formCollo.idCollo,
          lunghezza: this.$refs.lunghezza.$refs.input.$refs.input.value,
          larghezza: this.$refs.larghezza.$refs.input.$refs.input.value,
          altezza: this.$refs.altezza.$refs.input.$refs.input.value,
          peso: this.$refs.peso.$refs.input.$refs.input.value,
        }
        this.$set(this, 'formCollo', collo)
        if (flag !== null) {
          let array = JSON.parse(JSON.stringify(this.colli))
          array[flag] = this.formCollo
          this.$set(this, 'colli', array)
        } else {
          this.colli.push(this.formCollo)
        }
        this.$set(this, 'showNuovoCollo', false)
      },
      deleteCollo: function () {
        this.colli.splice(this.formCollo.idCollo - 1, 1)
        this.$set(this, 'showNuovoCollo', false)
        for (let i = 0; i < this.colli.length; i++) {
          let obj = this.colli[i]
          obj.idCollo = i + 1
        }
      },
      selectCollo: function (row, event, column) {
        let collo = {
          idCollo: row.idCollo,
          altezza: row.altezza,
          lunghezza: row.lunghezza,
          larghezza: row.larghezza,
          peso: row.peso,
          modifica: true
        }
        this.$set(this, 'formCollo', collo)
        this.$set(this, 'showNuovoCollo', true)
      },
      salvaPuntoRit: function (operazione) {
        let obj = {}
        if (operazione === 'UPD') {
          obj = this.formModificaPuntoRit
        } else if (operazione === 'ADD') {
          obj = this.formNuovoPuntoRit
        }
        this.setPuntoRit(operazione, obj)
      },
      cancellaPuntoRit: function () {
        this.setPuntoRit('DEL', this.puntoRitToDelete)
      },
      goToNuovoCollo: function () {
        let collo = {
          idCollo: this.colli.length + 1,
          altezza: '0',
          lunghezza: '0',
          larghezza: 0,
          peso: 0,
          modifica: false
        }
        this.$set(this, 'formCollo', collo)
        this.$set(this, 'showNuovoCollo', true)
      },
      changePage: function (page) {
        this.$set(this, 'currentPage', page)
        this.loadOrdine()
      },
      loadOrdine: function () {
        this.$set(this, 'loading', true)
        this.$http.get('situazioneordini/' + this.prefixApp.toLowerCase() + '/ordine', {
          params: {
            codLang: this.codLang,
            country: this.ordine.country,
            codForn: this.ordine.codForn,
            codSoc: this.ordine.codSoc,
            codMag: this.ordine.codMag,
            annoOrd: this.ordine.annoOrd,
            numOrd: this.ordine.numOrd,
            pag_action: (this.currentPage > 1) ? 'NEXT' : 'BEGIN',
            pag_from: this.currentPage,
            pag_for: this.pag_for
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'prodotti', response.body.data)
              if (this.currentPage === 1) {
                this.$set(this, 'nrPages', parseInt(response.body.attrib.pages))
                this.$set(this, 'nrItems', parseInt(response.body.attrib.size))
              }
            } else {
              this.$set(this, 'prodotti', [])
              this.$set(this, 'nrPages', 0)
              this.$set(this, 'nrItems', 0)
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
            this.$set(this, 'loading', false)
          })
      },
      /*  codRit: è il codice del punto di ritiro che restituisce il servizio in caso di modifica/creazione/cancellazione di un punto di ritiro
          opearzione: UPD/DEL/ADD a seconda dell'operazione eseguita dalla setPuntoRit
          Entrambi i parametri vengono passati solo in seguito alla chiamata della setPuntoRit dopo operazioni nella modal di gestione dei punti di ritiro
      */
      listPuntiRit: function (codRit, operazione) {
        this.$http.get('situazioneordini/' + this.prefixApp.toLowerCase() + '/puntirit', {
          params: {
            codLang: this.codLang,
            country: this.ordine.country,
            codForn: this.ordine.codForn
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'puntiRit', response.body.data)
              if (response.body.data.length > 0) {
                /*  codRit = undefined se sto chiamando la listPuntiRit sul caricamento della pagina. Se la richiamo
                    in seguito alla modifica, cancellazione o creazione di un punto di ritiro allora è != undefined
                 */
                if (codRit !== undefined) {
                  for (let i = 0; i < response.body.data.length; i++) {
                    let obj = response.body.data[i]
                    if (obj.codRit === codRit) {
                      this.$set(this.form, 'puntoRit', obj)
                      this.$set(this.form, 'ragSoc', obj.ragSoc)
                      this.$set(this.form, 'indRit', obj.indRit)
                      this.$set(this.form, 'capRit', obj.capRit)
                      this.$set(this.form, 'locRit', obj.locRit)
                      this.$set(this.form, 'provRit', obj.provRit)
                      this.$set(this.form, 'statoRit', obj.statoRit)
                    }
                  }
                } else {
                  let obj = response.body.data[0]
                  this.$set(this.form, 'puntoRit', obj)
                  this.$set(this.form, 'ragSoc', obj.ragSoc)
                  this.$set(this.form, 'indRit', obj.indRit)
                  this.$set(this.form, 'capRit', obj.capRit)
                  this.$set(this.form, 'locRit', obj.locRit)
                  this.$set(this.form, 'provRit', obj.provRit)
                  this.$set(this.form, 'statoRit', obj.statoRit)
                }
                /*  Se cancello un punto di ritiro che era selezionato nella form del punto di consegna
                    allora valorizzo la select e la form con il primo punto di ritiro che arriva dal servizio
                 */
                if (operazione === 'DEL') {
                  if (this.form.puntoRit.codRit === codRit) {
                    let obj = response.body.data[0]
                    this.$set(this.form, 'puntoRit', obj)
                    this.$set(this.form, 'ragSoc', obj.ragSoc)
                    this.$set(this.form, 'indRit', obj.indRit)
                    this.$set(this.form, 'capRit', obj.capRit)
                    this.$set(this.form, 'locRit', obj.locRit)
                    this.$set(this.form, 'provRit', obj.provRit)
                    this.$set(this.form, 'statoRit', obj.statoRit)
                  }
                }
              }
            } else {
              this.$set(this, 'puntiRit', [])
              this.$set(this.form, 'puntoRit', {})
              this.$set(this.form, 'ragSoc', '')
              this.$set(this.form, 'indRit', '')
              this.$set(this.form, 'capRit', '')
              this.$set(this.form, 'locRit', '')
              this.$set(this.form, 'provRit', '')
              this.$set(this.form, 'statoRit', '')
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      setPuntoRit: function (operazione, puntoRit) {
        this.$http.post('situazioneordini/' + this.prefixApp.toLowerCase() + '/puntorit',
          {
            codLang: this.codLang,
            codStato: this.ordine.country,
            codForn: this.ordine.codForn,
            op: operazione,
            codRit: (operazione !== 'ADD') ? puntoRit.codRit : '',
            ragSoc: puntoRit.ragSoc,
            indRit: puntoRit.indRit,
            capRit: puntoRit.capRit,
            locRit: puntoRit.locRit,
            provRit: puntoRit.provRit.toUpperCase(),
            statoRit: puntoRit.statoRit
          }
        )
          .then(response => {
            if (response.body.rc === 0) {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'success',
                duration: process.env.duration
              })
              this.$set(this, 'showAddPuntoRit', false)
              this.$set(this, 'showCancellaModal', false)
              this.listPuntiRit(response.body.attrib.codRit, operazione)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      setPuntoRitTemporaneo: function () {
        this.$set(this, 'showAddPuntoRit', false)
        this.$set(this, 'showCancellaModal', false)
        let puntoRit = {
          capRit: '',
          codRit: '',
          indRit: '',
          locRit: '',
          provRit: '',
          ragSoc: '',
          statoRit: ''
        }
        this.$set(this.form, 'puntoRit', puntoRit)
        this.$set(this.form, 'ragSoc', this.formNuovoPuntoRit.ragSoc)
        this.$set(this.form, 'indRit', this.formNuovoPuntoRit.indRit)
        this.$set(this.form, 'capRit', this.formNuovoPuntoRit.capRit)
        this.$set(this.form, 'locRit', this.formNuovoPuntoRit.locRit)
        this.$set(this.form, 'provRit', this.formNuovoPuntoRit.provRit)
        this.$set(this.form, 'statoRit', '')
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../assets/less/general.less";

  .colli-modal {
    .form {
      .row-custom {
        margin-bottom: 5px;
        .collo-label {
          .set-font(@size: 11px, @color: @greenRiva, @family: 'os-semibold');
          text-align: right;
          line-height: 22px;
          overflow: hidden;
          text-overflow: ellipsis;
          text-transform: uppercase;
          letter-spacing: 1px;
        }
        .collo-value {
          .custom-input {
            .el-input__inner {
              border: 1px solid #dcdfe6;
              height: 22px !important;
              padding: 0 5px;
              text-align: left;
            }
          }
        }
      }
    }
    .bottoni {
      padding-top: 5px;
    }
  }

  .puntorit-modal {
    .el-dialog {
      .el-dialog__header {
        border-bottom: 0;
      }
      .el-dialog__body {
        .el-tabs {
          .el-tabs__item {
            width: 50%;
          }
          .el-tabs__content {
            padding-top: 15px;
          }
          .el-tabs__item {
            div {
              height: 30px;
            }
          }
        }
        .form-puntorit {
          .form-elemento {
            margin-top: 5px;
            .puntorit-label {
              .set-font(@size: 11px, @color: @greenRiva, @family: 'os-semibold');
              text-align: right;
              line-height: 22px;
              overflow: hidden;
              text-overflow: ellipsis;
              text-transform: uppercase;
              letter-spacing: 1px;
            }
            .puntorit-value {
              .custom-input {
                .el-input__inner {
                  height: 22px !important;
                  padding: 0 5px;
                  border: 1px solid #dcdfe6;
                }
              }
              .custom-select-el {
                .el-input__inner {
                  height: 22px !important;
                  border: 1px solid #dcdfe6;
                  padding: 0 5px;
                }
              }
            }
          }
        }
        .bottone-puntorit {
          margin-top: 30px;
          text-align: right;
        }
      }
    }
  }

  .nuovo-buono {
    .header-tab {
      height: 60px;
      text-align: center;
      .my-label {
        line-height: 55px;
        height: 45px;
        .set-font(@color: @oroRiva; @size: 22px; @family: 'os-semibolditalic');
        letter-spacing: 2px;
      }
    }
    .form {
      margin-top: 20px;
      .form-label {
        .set-font(@size: 14px, @weight: bold);
        line-height: 35px;
        display: inline-block;
      }
      .form-add {
        display: inline-block;
        margin-left: 20px;
      }
      .riga {
        margin-top: 5px;
        .elemento-sx {
          padding-left: 0;
          .blocco-indirizzo {
            padding-left: 0;
            padding-right: 5px;
          }
        }
        .elemento-dx {
          padding-right: 0;
          .el-input__inner {
            text-align: right !important;
            font-style: italic !important;
          }
        }
        .custom-select-el {
          .el-input__inner {
            height: 22px !important;
            border: 1px solid #dcdfe6;
            padding: 0 5px;
          }
          .is-focus {
            .el-input__inner {
              border-color: @greenRiva;
            }
          }
        }
        .custom-date-picker {
          .el-input__inner {
            height: 22px !important;
            padding-left: 30px !important;
            text-align: right !important;
            border: 1px solid #dcdfe6;
          }
          .el-input__inner:focus {
            border-color: @greenRiva;
          }
          .el-input__prefix {
            left: 0;
          }
        }
        .custom-input {
          .el-input__inner {
            border: 1px solid #dcdfe6;
            height: 22px !important;
            padding: 0 5px;
          }
        }
      }
      .label-note {
        margin-top: 10px;
        .set-font(@weight: bold, @size: 14px);
      }
    }
    .colonna-sx {
      padding-top: 5px;
      border-right: 1px solid @greenRiva;
      margin-bottom: 20px;
      .el-button:focus {
        outline-width: 0;
      }
      .autocomplete {
        margin-top: 10px;
        text-align: right;
      }
      .el-table {
        margin-top: 11px;
        min-height: 330px;
        overflow: auto;
        .el-table__body {
          tbody {
            tr {
              td {
                &.center {
                  .cell {
                    display: table-cell;
                    vertical-align: middle;
                    line-height: 14px;
                    overflow: visible;
                    text-overflow: unset;
                    white-space: normal;
                  }
                }
                .cell {
                  height: 25px;
                  .el-input {
                    .el-input__inner {
                      height: 18px;
                      border-radius: 0;
                      text-align: center;
                      padding: 0 3px;
                    }
                    .el-input__inner:focus {
                      border-color: @greenRiva;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    .colonna-dx {
      padding-top: 5px;
      margin-bottom: 20px;
      .el-button:focus {
        outline-width: 0;
      }
      .el-table {
        margin-top: 10px;
        min-height: 50px;
        max-height: 310px;
        overflow: auto;
        .el-table__header {
          thead {
            th {
              padding: 5px 0;
              .cell {
                padding: 0 !important;
                .header-colli {
                  padding: 0;
                  width: 100%;
                  line-height: 10px;
                  vertical-align: middle;
                  div {
                    line-height: 16px;
                    padding: 0 5px;
                    width: 100%;
                    text-align: center;
                  }
                }
              }
            }
          }
        }
        .el-table__empty-block {
          height: 50px;
        }
      }
      .totali {
        border: 1px solid #cbb385;
        padding: 20px;
        position: absolute;
        bottom: 0;
        width: 94%;
        margin: auto;
        .totali-label {
          .set-font(@color: @oroRiva, @size: 18px);
          text-align: left;
          letter-spacing: 2px;
          line-height: 30px;
        }
        .totali-value {
          .set-font(@color: @greenRiva, @size: 18px, @weight: bold);
          text-align: center;
        }
      }
    }
    .salva {
      text-align: right;
      margin-bottom: 15px;
      margin-top: 15px;
    }
    .secondButton {
      text-align: right;
      .fa-icon {
        color: @rossoRiva;
      }
      .el-button {
        margin-bottom: 10px;
        letter-spacing: 0;
      }
    }
    .location {
      line-height: 33px;
    }
  }

  @media screen and (max-width: 1250px) {
    .nuovo-buono {
      .colonna-sx {
        border-right: 0;
      }
      .colonna-dx {
        .totali {
          margin-top: 25px;
          position: relative;
          width: 100%;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Fornitura/SituazioneOrdini/NuovoBuono.vue